import { SEARCH_TEXT } from "../constants";

export const searchText = (data) => {
    return {
        type: SEARCH_TEXT,
        data: data,
    };
};